import styled from "styled-components";
import {ButtonsActiveIndicatorDefaultBox} from "./buttons-active-indicator.default.box";

export const ButtonsActiveIndicatorSIBox = styled(ButtonsActiveIndicatorDefaultBox)`
    background: none;
    width: 0;
`;
